// 面试列表
import Model from "@/lib/model/model";
import Auth from "@/lib/common/auth";
import request from "@/lib/request/request";

export class ExamCount extends Model {
  beforeStart = 0; // 未开始
  afterEnd = 0; // 已结束
  isPlaying = 0; // 进行中
  all = 0; // 全部
}

export class ExamItem extends Model {
  examId = 0;
  examVersionId = 0;
  examVersionIndex = 0;
  companyId = 0;
  connectCode = "";
  connectCodeForInvite = ""; // 3开头的码，二维码定向邀请码
  name = "";
  innerName = ""; // 对内名称
  remark = "";
  positionId = 0;
  positionName = "";
  noEnding = 0;
  beginTime = "";
  endTime = "";
  questionNumber = 0;
  useTimeSecond = 0;
  createdTime = "";
  lastUpdateTime = "";
  canOpenJoin = 0;

  // 前端字段
  hasVersion = false;
  isLast = false;
  isSubVersion = false;
  fatherExamId = 0;
  dataChange = true;
}

export class ExamSearch extends Model {
  companyId = Auth.companyId;
  nameOrRemark = "";
  beforeStart = 0;
  afterEnd = 0;
  isPlaying = 0;
  page = 0;
  pageSize = 0;
  returnAll = false;
}

export class ExamVersionSearch extends Model {
  companyId = Auth.companyId;
  examId = 0;
  needCandidateCount = true; // 需要统计量
}

export class ExamList extends Model {
  examCount = new ExamCount();
  list = [new ExamItem()];
  count = 0; // 总计
  page = 0; // 当前分页
  pageSize = 0; // 当前页大小
  pageMax = 0; // 最大有效分页

  static getList(param: ExamSearch) {
    return request.postInterviewApi("hr/exam/list", param).then(res => {
      return new ExamList().assign(res.data.data);
    });
  }

  // 获取面试小程序二维码
  static wsaCode(connectCode: string) {
    return request
      .postInterviewApi("public/common/qrConfig", { connectCode })
      .then(resp => {
        return resp.data;
      });
  }

  static examUrl(connectCode: string) {
    return request
      .postInterviewApi("public/common/connectUrl", { connectCode })
      .then(resp => {
        return resp.data;
      });
  }

  // 检查所依赖视频是否全部生成完成
  static checkVideoFinish(param: { examId: number; examVersionId: number }) {
    return request
      .postInterviewApi("hr/exam/checkVideoFinish", param)
      .then(resp => {
        return resp.data;
      });
  }

  static joinStatus(connectCode: string) {
    return request
      .postInterviewApi("public/common/joinStatus", { connectCode })
      .then(resp => {
        return resp.data;
      });
  }

  static getVersionList(param: ExamVersionSearch) {
    return request.postInterviewApi("hr/exam/versions", param).then(resp => {
      return resp.data;
    });
  }
}

export class ExamSmallItem extends Model {
  examId = 0;
  connectCode = "";
  name = "";
  remark = "";
  canOpenJoin = 0;
}

export class ExamAllSearch extends Model {
  nameOrRemark = "";
  examIdList: number[] = [];
  page = 1;
  pageSize = 10;
  returnAll = false;
}

export class ExamAllList extends Model {
  list = [new ExamSmallItem()];
  count = 0; // 总计
  page = 0; // 当前分页
  pageSize = 0; // 当前页大小
  pageMax = 0; // 最大有效分页

  static getList(param: ExamAllSearch) {
    return request.postInterviewApi("hr/exam/smallList", param).then(res => {
      return new ExamAllList().assign(res.data.data);
    });
  }
}
